export const CLIENT_HOME_ROLES = [
  "Customer User",
  "Client Admin",
  "Client Accounting",
  "Client Operations",
  "Client Processors",
  "Diligent Search User",
  "State Reporter",
] as const;

export const splitRoles = (userRoles?: string): string[] => {
  if (!userRoles) return [];
  return userRoles
    .split(",")
    .map((role) => role.trim())
    .filter(Boolean);
};

export const hasAnyRole = (
  userRoles?: string,
  allowedRoles: readonly string[] = []
): boolean => {
  const roles = splitRoles(userRoles);
  return roles.some((role) => allowedRoles.includes(role));
};

export const isClientHomeRole = (userRoles?: string): boolean => {
  return hasAnyRole(userRoles, CLIENT_HOME_ROLES);
};
